import React from 'react';
import { Link } from 'react-router-dom';
import { FiFacebook, FiInstagram, FiMail, FiMapPin, FiPhone } from 'react-icons/fi';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-lions-dark text-white">
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Over ons */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-lions-yellow">Lions Club Hoorn De Doelen</h3>
            <p className="mb-4 text-gray-300">
              Lions Club Hoorn De Doelen zet zich in voor lokale en internationale goede doelen. 
              Samen maken we een verschil in de gemeenschap.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white hover:text-lions-yellow transition-colors"
                aria-label="Facebook"
              >
                <FiFacebook size={24} />
              </a>
              <a 
                href="https://www.instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white hover:text-lions-yellow transition-colors"
                aria-label="Instagram"
              >
                <FiInstagram size={24} />
              </a>
            </div>
          </div>

          {/* Snelle links */}

          <div>
            <h3 className="text-xl font-bold mb-4 text-lions-yellow">Snelle links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/over-ons" className="text-gray-300 hover:text-white transition-colors">
                  Over ons
                </Link>
              </li>
              {/* <li>
                <Link to="/projecten" className="text-gray-300 hover:text-white transition-colors">
                  Projecten
                </Link>
              </li>
              <li>
                <Link to="/nieuws" className="text-gray-300 hover:text-white transition-colors">
                  Nieuws
                </Link>
              </li>
              <li>
                <Link to="/agenda" className="text-gray-300 hover:text-white transition-colors">
                  Agenda
                </Link>
              </li> */}
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Evenementen */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-lions-yellow">Komende evenementen</h3>
            <div className="space-y-4">
             
              <div>
                <h4 className="font-bold">Bridgen voor het Goede Doel</h4>
                <p className="text-gray-300">2 november 2025</p>
                <p className="text-gray-300">De Witte Valk, Zwaag</p>
              </div>
              <div>
                <h4 className="font-bold">Dansfeest 60 & 70's </h4>
                <p className="text-gray-300">16 november 2025 16 - 20 uur</p>
                <p className="text-gray-300">Restaurant De Nadorst, Blokker</p>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-lions-yellow">Contact</h3>
            <ul className="space-y-2">
              <li className="flex items-start space-x-2">
                <FiMapPin className="mt-1 flex-shrink-0 text-lions-yellow" />
                <span className="text-gray-300">
                  Restaurant De Nadorst<br />
                  Westerblokker 171<br />
                  1695AE Blokker
                </span>
              </li>
              <li className="flex items-center space-x-2">
                <FiMail className="flex-shrink-0 text-lions-yellow" />
                <a 
                  href="mailto:hoorn.de.doelen@lions.nl" 
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  hoorn.de.doelen@lions.nl
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <FiPhone className="flex-shrink-0 text-lions-yellow" />
                <a 
                  href="tel:0229232679" 
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  0229 232679
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="bg-black py-4">
        <div className="container-custom text-center text-gray-400">
          <p>© {currentYear} Lions Club Hoorn De Doelen. Alle rechten voorbehouden.</p>
          <p className="mt-2">
            <Link to="/privacy" className="hover:text-white transition-colors">
              Privacyverklaring
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 